import { fileUrl } from "./api";

// Render a shareable 1080x1350 player card PNG to a Blob using canvas.
export async function generatePlayerCard(p) {
  const W = 1080, H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background
  const grad = ctx.createLinearGradient(0, 0, 0, H);
  grad.addColorStop(0, "#141414");
  grad.addColorStop(1, "#000000");
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, H);

  // Photo (if available)
  if (p.photo_path) {
    try {
      const img = await loadImage(fileUrl(p.photo_path));
      const s = Math.min(img.width, img.height);
      const sx = (img.width - s) / 2, sy = (img.height - s) / 2;
      ctx.drawImage(img, sx, sy, s, s, 60, 60, 960, 720);
    } catch (err) { console.debug("card photo skipped", err?.message); }
  } else {
    ctx.fillStyle = "#1a1a1a";
    ctx.fillRect(60, 60, 960, 720);
  }

  // Gradient overlay bottom of photo
  const overlay = ctx.createLinearGradient(0, 500, 0, 780);
  overlay.addColorStop(0, "rgba(0,0,0,0)");
  overlay.addColorStop(1, "rgba(0,0,0,0.95)");
  ctx.fillStyle = overlay;
  ctx.fillRect(60, 500, 960, 280);

  // AfriGoall logo
  ctx.fillStyle = "#e65f2b";
  ctx.fillRect(60, 60, 60, 60);
  ctx.fillStyle = "#000";
  ctx.font = "bold 48px Oswald, sans-serif";
  ctx.fillText("A", 78, 108);

  ctx.fillStyle = "#fff";
  ctx.font = "bold 28px Oswald, sans-serif";
  ctx.fillText("AFRIGOAL", 140, 105);

  // Verified badge
  if (p.verified) {
    ctx.fillStyle = "#eab308";
    ctx.fillRect(830, 90, 180, 50);
    ctx.fillStyle = "#000";
    ctx.font = "bold 22px Oswald, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("✓ VERIFIED", 920, 122);
    ctx.textAlign = "left";
  }

  // Name
  ctx.fillStyle = "#fff";
  ctx.font = "bold 84px Oswald, sans-serif";
  ctx.fillText((p.name || "").toUpperCase(), 80, 700);

  // Meta
  ctx.fillStyle = "#e65f2b";
  ctx.font = "bold 28px Oswald, sans-serif";
  ctx.fillText(`${(p.position || "—").toUpperCase()} · ${p.country || "—"}`, 80, 745);

  // Stats grid
  const stats = [
    ["Age", p.age || "—"],
    ["Height", p.height_cm ? `${p.height_cm}cm` : "—"],
    ["Weight", p.weight_kg ? `${p.weight_kg}kg` : "—"],
    ["Foot", p.dominant_foot || "—"],
    ["Speed", p.speed_kmh ? `${p.speed_kmh}km/h` : "—"],
    ["Passport", p.passport_status || "—"],
  ];
  stats.forEach(([label, val], i) => {
    const col = i % 3, row = Math.floor(i / 3);
    const x = 80 + col * 320, y = 850 + row * 130;
    ctx.strokeStyle = "#333";
    ctx.strokeRect(x, y, 300, 110);
    ctx.fillStyle = "#666";
    ctx.font = "600 18px Manrope, sans-serif";
    ctx.fillText(label.toUpperCase(), x + 20, y + 35);
    ctx.fillStyle = "#eab308";
    ctx.font = "bold 44px Oswald, sans-serif";
    ctx.fillText(String(val), x + 20, y + 88);
  });

  // Bottom stripe
  ctx.fillStyle = "#e65f2b";
  ctx.fillRect(0, H - 60, W / 3, 60);
  ctx.fillStyle = "#eab308";
  ctx.fillRect(W / 3, H - 60, W / 3, 60);
  ctx.fillStyle = "#2A9D8F";
  ctx.fillRect((W * 2) / 3, H - 60, W / 3, 60);

  // Footer text
  ctx.fillStyle = "#fff";
  ctx.font = "bold 24px Oswald, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText("VIEW FULL PROFILE ON AFRIGOAL.COM", W / 2, H - 90);
  ctx.textAlign = "left";

  return new Promise((resolve) => canvas.toBlob((b) => resolve(b), "image/png", 0.95));
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
